import * as React from 'react'
import {
	type ComponentProps,
	type ComponentPropsWithoutRef,
	type ComponentRef,
	useMemo,
} from 'react'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'
import { useLingui } from '@lingui/react/macro'
import { getNames, registerLocale } from 'i18n-iso-countries'

registerLocale(require('i18n-iso-countries/langs/fr.json'))
registerLocale(require('i18n-iso-countries/langs/en.json'))

type Ref = ComponentRef<typeof Select>
type CountrySelectProps = ComponentPropsWithoutRef<typeof Select> & {
	className?: ComponentProps<typeof SelectTrigger>['className']
}

export const CountrySelect = React.forwardRef<Ref, CountrySelectProps>(
	({ className, ...props }, ref) => {
		const { i18n } = useLingui()

		const options = useMemo(() => {
			const countries = getNames(i18n.locale)

			return Object.entries(countries)
				.sort(([, nameA], [, nameB]) => nameA.localeCompare(nameB))
				.map(([value, label]) => ({ label, value }))
		}, [i18n.locale])

		return (
			<Select {...props}>
				<SelectTrigger
					className={className}
					ref={ref}
				>
					<SelectValue />
				</SelectTrigger>

				<SelectContent>
					{options.map((option) => (
						<SelectItem
							key={option.label}
							value={option.value}
						>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		)
	},
)

CountrySelect.displayName = 'CountrySelect'
